import { ICoreContext } from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { getAttributeStringOrDefault, getAttributesLocale } from '../../../shared-utils/attributes';
import { getBrandSchemeByIdAsync } from '../../../actions/get-brand-scheme.action';

export interface IBrandScheme {
    id: string;
    name?: string;
    imageUrl?: string;
}

export const useBrandSchemes = (context: ICoreContext, attributes: AttributeValue[] | undefined) => {
    const attributeLocale = getAttributesLocale(context.request.locale);
    const [brandSchemes, setBrandSchemes] = React.useState<IBrandScheme[] | undefined>(undefined);

    React.useEffect(() => {
        if (!attributes) {
            return;
        }

        const brandSchemesAttrValue = getAttributeStringOrDefault(attributes,
            attributeLocale.specialBadges,
            '');

        if (!brandSchemesAttrValue) {
            return;
        }

        const brandSchemes: IBrandScheme[] = brandSchemesAttrValue.split('|').map(x => ({
                id: x
            }
        ));
        const promises = brandSchemesAttrValue
            .split('|')
            .map((brandScheme) => getBrandSchemeByIdAsync(context.actionContext, brandScheme));

        Promise.all(promises)
            .then((brandSchemeResults) => {
                // Do it like this so we maintain the id if no brand scheme for the id is found. That way we can still list the id at least
                brandSchemeResults.forEach((brandSchemeResult) => {
                    if (brandSchemeResult) {
                        const updateBrandScheme = brandSchemes.find(x => x.id === brandSchemeResult.BrandSchemeId);
                        if (!updateBrandScheme) {
                            return;
                        }
                        updateBrandScheme.name = brandSchemeResult.BrandSchemeName;
                        updateBrandScheme.imageUrl = brandSchemeResult.ImageUrl;
                    }
                });
            })
            .catch((error) => {
                console.error(`Could not get brand scheme by id`, error);
            })
            .finally(() => {
                setBrandSchemes(brandSchemes);
            });
    }, []);

    return [brandSchemes];
};